import React from 'react';
import PropTypes from 'prop-types';
import classes from './styles.module.scss';

const Loader = ({
  size, color, className, borderWidth,
}) => (
  <div className={`${classes.loader_wrapper} ${className}`}>
    <span style={{
      width: size,
      height: size,
      borderColor: color,
      borderWidth,
    }}
    />
  </div>
);

Loader.propTypes = {
  size: PropTypes.number,
  borderWidth: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
};

Loader.defaultProps = {
  size: 40,
  borderWidth: 3,
  color: '#355ECA',
  className: '',
};

export default Loader;
